var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgBitcoin = function SvgBitcoin(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
    fill: "#F7931A"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M14.363 10.56c-.37 1.44-2.585.702-3.323.517l.627-2.51c.739.147 3.065.48 2.696 1.993Zm-.406 4.062c-.407 1.587-3.065.738-3.951.517l.701-2.77c.886.185 3.656.628 3.25 2.253Zm2.953-4.062c.222-1.55-.96-2.363-2.584-2.917l.517-2.067-1.293-.333-.517 2.031c-.332-.074-.701-.148-1.033-.221l.517-2.031-1.293-.333-.517 2.068c-.295-.074-.554-.11-.812-.184l-1.772-.444-.333 1.367s.96.221.923.221c.517.11.628.48.591.739l-.59 2.363c.036 0 .073.037.147.037-.037 0-.074-.037-.148-.037l-.849 3.323c-.074.148-.221.406-.59.295l-.924-.221-.627 1.44 1.661.406c.296.074.628.147.923.221l-.517 2.105 1.293.332.517-2.067c.332.11.701.184 1.033.258l-.516 2.068 1.292.332.517-2.105c2.178.407 3.84.259 4.541-1.698.554-1.588-.037-2.474-1.181-3.065.812-.221 1.44-.738 1.624-1.883Z",
    fill: "white"
  })));
};
export default SvgBitcoin;